import axios from 'axios';
import { hostInformacionComercial } from '../../configuraciones';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

/** DATOS INICIALES */
const initialState = {
    motivos: [],
    solicitudes: [],
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    },
    counts: {
        TODOS: 0,
        E1_ENVIADA_ASOCIADO: 0,
        E2_RECHAZADA_AC: 0,
        E3_ACEPTADA_AC: 0,
        E4_E5_REVISION_IC: 0,
        E6_RECHAZADA_IC: 0,
        E7_ACEPTADA_CON_INFORME: 0,
        E8_E9_UI: 0,
        TOTAL_RECHAZADAS: 0,
        TOTAL_ACEPTADAS: 0
    },
    loading: false,
    error: null
};

const REGISTRAR_SOLICITUD_EXITO = 'REGISTRAR_SOLICITUD_EXITO';
const OBTENER_SOLICITUDES_EXITO = 'OBTENER_SOLICITUDES_EXITO';
const ACTUALIZAR_SOLICITUD_EXITO = 'ACTUALIZAR_SOLICITUD_EXITO';

export const obtenerSolicitudes = createAsyncThunk(
    OBTENER_SOLICITUDES_EXITO,
    async ({ estatus = 'TODOS', id_login, search = '', page = 1, limit = 10 } = {}, { rejectWithValue }) => {
        try {
            const url = `${hostInformacionComercial}Solicitud/filtrar`;
            const res = await axios.get(url, {
                params: {
                    estatus,
                    id_login,
                    busqueda: search,
                    page,
                    limit
                }
            });
            return res.data; // Contiene data, pagination y counts
        } catch (error) {
            console.error("Error al obtener solicitudes:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const registrarSolicitud = createAsyncThunk(
    REGISTRAR_SOLICITUD_EXITO,
    async (formData, { rejectWithValue }) => {
        try {
            const url = `${hostInformacionComercial}Solicitud/registrar`;
            const res = await axios.post(url, formData);
            return res.data.data;
        } catch (error) {
            console.error("Error al registrar solicitud:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const actualizarSolicitud = createAsyncThunk(
    ACTUALIZAR_SOLICITUD_EXITO,
    async ({ id_solicitud, formData }, { rejectWithValue }) => {
        try {
            const url = `${hostInformacionComercial}Solicitud/actualizar/${id_solicitud}`;
            const res = await axios.put(url, formData);
            return res.data.data;
        } catch (error) {
            console.error("Error al actualizar solicitud:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const informacionComercialSlice = createSlice({
    name: 'informacionComercial',
    initialState,
    reducers: {
        resetError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Obtener Solicitudes
            .addCase(obtenerSolicitudes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(obtenerSolicitudes.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.solicitudes = payload.data || [];
                state.pagination = payload.pagination || state.pagination;
                state.counts = payload.counts || state.counts;
            })
            .addCase(obtenerSolicitudes.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            // Registrar Solicitud
            .addCase(registrarSolicitud.pending, (state) => {
                state.loading = true;
            })
            .addCase(registrarSolicitud.fulfilled, (state, { payload }) => {
                state.loading = false;
                if (payload) {
                    state.solicitudes.unshift(payload);
                }
            })
            .addCase(registrarSolicitud.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            // Actualizar Solicitud
            .addCase(actualizarSolicitud.pending, (state) => {
                state.loading = true;
            })
            .addCase(actualizarSolicitud.fulfilled, (state, { payload }) => {
                state.loading = false;
                if (payload) {
                    const idx = state.solicitudes.findIndex(s => s.id_solicitud === payload.id_solicitud);
                    if (idx !== -1) {
                        state.solicitudes[idx] = { ...state.solicitudes[idx], ...payload };
                    }
                }
            })
            .addCase(actualizarSolicitud.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            });
    }
});

export const { resetError } = informacionComercialSlice.actions;
export default informacionComercialSlice.reducer;
